module.exports = __webpack_public_path__ + "img/card.7dd00fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card.png
// module id = Pzc5
// module chunks = 1